import { type GraphPath, IPF_NETWORK_VIEWER } from '@ipfabric/utils';
import {
  type GraphState,
  isTopologyGraphMetadata,
} from 'components/Graph/GraphState';
import { array } from 'fp-ts';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectTopologyPathsWithoutNetworkViewer: (
  s: GraphState,
) => GraphPath[] = createScopedSelector(() =>
  createSelector(
    (s) =>
      isTopologyGraphMetadata(s.graphMetadata)
        ? s.graphMetadata.parameters.paths
        : array.empty,
    (paths) => paths.filter((path) => path !== IPF_NETWORK_VIEWER),
  ),
);
